import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['hatebu', 'hatebuImage']

  toggleHatebu() {
    if (this.hatebuImageTarget.width <= 1) {
      this.hatebuTarget.style.display = 'none'
    }
  }
}
